import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TagEditPage } from './tag-edit/tag-edit.page';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { AuthService } from 'src/app/_provider/auth.service';
import { TicketTagColored, BoardService, TicketTag } from 'src/app/_provider/boards/board.service';

@Component({
  selector: 'app-tag-overview',
  templateUrl: './tag-overview.page.html',
  styleUrls: ['./tag-overview.page.scss'],
})
export class TagOverviewPage implements OnInit {

  public tagsColored: TicketTagColored[] = []
  public searchText: string = ""

  public isSelect: boolean = false
  public selectedTags: TicketTagColored[] = []
  public tagChanged: (tags: TicketTagColored, toAdd: boolean) => void

  constructor(
    private modalCtrl: ModalController,
    public boardSrv: BoardService,
    private darkmode: DarkmodeService,
    private feedback: FeedbackService,
    public authSrv: AuthService
  ) { }

  ngOnInit() {
    this.search()
  }

  public search(){
    this.tagsColored = this.boardSrv.tags.filter(t => t.description.toLowerCase().includes(this.searchText.toLowerCase())).map((tag)=>{
      const rgb: { r: number; g: number; b: number; } = this.darkmode.hexToRgb(tag.color)
      return {
        id: tag.id,
        description: tag.description,
        rgba: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.15)`,
        hex: tag.color
      }
    })
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async addTag(){
    await this.feedback.openModal<TicketTag>(TagEditPage, {isNew: true}, (result: HttpFunctionResult<TicketTag>)=>{
      if(!result.success) return
      this.boardSrv.tags.push(result.data)
      this.search()
    })
  }

  public async editTag(tag: TicketTagColored){
    if(this.isSelect){
      if(this.selectedTags.find(t => t.id == tag.id)){
        this.selectedTags.splice(this.selectedTags.findIndex(t => t.id == tag.id), 1)
        this.tagChanged(tag, false)
      }else{
        this.selectedTags.push(tag)
        this.tagChanged(tag, true)
      }
    }else{
      await this.feedback.openModal<TicketTag>(TagEditPage, {isNew: false, tag: tag}, (result: HttpFunctionResult<TicketTag>)=>{
        if(!result.success) return this.search()
        this.boardSrv.tags.splice(this.boardSrv.tags.findIndex(t => t.id == tag.id), 1, result.data)
        this.search()
      })
    }
  }

  public isSelected(tag: TicketTagColored){
    if(this.selectedTags.find(t => t.id == tag.id)) return true
    return false
  }

}
